import { graficoDonutClassificacoesStyles } from './GraficoDonutClassificacoes.style'

export function graficoDonutClassificacoesIO() {
  return {
    styles: graficoDonutClassificacoesStyles
  }
}

export type GraficoDonutClassificacoesIO = ReturnType<typeof graficoDonutClassificacoesIO>
